// prestationsServices.js
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/prestations`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/// GET
export const getPrestations = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allprestations`, {
      headers: { ...authHeaders() },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des prestations:", error);
    return [];
  }
};

/// POST (création JSON, pas multipart)
export const createPrestation = async (newPrestation) => {
  try {
    const response = await axios.post(`${apiUrl}/addprestation`, newPrestation, {
      headers: { ...authHeaders() },
    });
    if (![200, 201].includes(response.status)) {
      throw new Error("Failed to add new prestation");
    }
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de l'ajout de la prestation:",
      error?.response?.data || error
    );
    return null;
  }
};

/// POST (UPLOAD) — laisser Axios gérer la boundary; ajouter x-category
export const uploadImagePrestation = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/uploadImage`, formData, {
      headers: {
        ...authHeaders(),
        "x-category": "prestations",
      },
    });
    return response.data; // { filePath: "/uploads/prestations/xxx.png" }
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image de prestation :", error);
    return null;
  }
};

/// PUT
export const updatePrestation = async (updatedPrestation) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateprestation/${updatedPrestation.id}`,
      updatedPrestation,
      { headers: { ...authHeaders() } }
    );
    if (response.status !== 200) throw new Error("Failed to update prestation");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la prestation:", error);
    return null;
  }
};

/// DELETE
export const deletePrestation = async (prestationId) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteprestation/${prestationId}`, {
      headers: { ...authHeaders() },
    });
    if (response.status !== 200) throw new Error("Failed to delete prestation");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de la prestation:", error);
    return null;
  }
};
